// URls
export const URLs = Object.freeze({
    privacyURL: "https://www.ubme.com/privacy.html",
    termsURL: "https://www.ubme.com/terms.html",
});

// Apis
export const API = Object.freeze({
    businessLoginApi: 'BusinessLogin',
    uploadUserProfileImageApi: 'UploadUserProfileImage',
    uploadUserCoverImageApi: 'UploadUserCoverImage',
    removeUserProfileCoverImageApi: 'RemoveUserProfileCoverImage',
    updateBusinessAddressApi: 'UpdateBusinessAddress',
    checkOldPasswordApi: 'CheckOldPassword',
    updateUserInfoApi: 'UpdateUserInfo',
    verifyAccountUsernameApi: 'VerifyAccountUserName',
    verifyAccountEmailApi: 'VerifyAccountEmail',
    verifyAccountPhonenumberApi: 'VerifyAccountPhoneNumber',
    verifyBusinessExistApi: 'VerifyBusinessExist',
    getUserProfileDetailApi: 'GetUserProfileDetail',
    getAvailableUsersApi: 'AvailableUsers',
    getParticipantUserListApi: 'GetParticipantUserList',
    userForgetPasswordApi: 'LinkUpsUserForgetPassword',
    businessRegistrationApi: 'BusinessRegistration',
    businessUsernameSuggestionApi: 'BusinessUsernameSuggestions',
    usercheckInApi: 'UserCheckIn',
    userCheckoutPlaceApi: 'UserCheckOutPlace',
    getBusinessDetailsApi: 'GetBusinessDetails',
    getUserImagesByUserIdApi: 'GetUserImagesByUserId',
    getBusinessAccountDetailsApi: 'GetBusinessAccountDetails',
    updateProfileBioApi: 'UpdateProfileBio',
    addUserPointApi: 'AddUserPoint',

    addBusinessDealApi: 'AddBusinessDeal',
    getCurrentDealApi: 'GetCurrentDeal',
    deleteBusinessDealsByDealIdApi: 'DeleteBusinessDealsByDealId',

    addFeedByUserApi: 'AddFeedByUser',
    deleteUserOwnFeedApi: 'DeleteUserOwnFeed',
    getUserOwnLocalFeedByFeedTypeApi: 'GetUserOwnLocalFeedByFeedType',
    updateFeedByUserApi: 'UpdateFeedByUser',

    getCheckinDealClaimedCountApi: 'GetCheckinDealClaimedCount1',
    getCheckinDealClaimedDetailsApi: 'GetCheckinDealClaimedDetails',
    getBusinessActivityApi: 'GetBusinessActivity',
    updateBusinessPanelSeenStatusApi: 'UpdateBusinessPanelSeenStatus',
    getCheckinDetailsApi: 'GetCheckinDetails',
    getDealClaimedDetails: 'GetDealClaimedDetails',
    getPotentialReachCountApi: 'GetPotentialReachCount',

    addEventByUserApi: 'AddEventByUser',
    getEventByUserApi: 'GetEventsByUserTimeZoneWithImage',
    getUserOwnEventsApi: 'GetUserOwnEvents',
    updateEventByUserApi: 'UpdateEventByUser',
    deleteEventByUserApi: 'DeleteEventByUser',

    callSendMailApi: 'CallSendMail',
    callSendMessageApi: 'CallSendMessage',
    saveOnlineOrderMessageApi: 'SaveOnlineOrderMessage',
    stripeRefundApi: 'StripeRefund',
    getOrderNotificationDetailsApi: 'GetBusinessOrderNotificationDetails',
    saveBusinessOrderNotificationDetailsApi: 'SaveBusinessOrderNotificationDetails',
});

// //Messages
// export const Message = Object.freeze({
//     invalidCredentialsMsg: "Invalid Credentials.",
//     bothFieldsAreRequiredMsg: "Both Fields are Required.",
//     yourNameMustHaveAtLeast3CharactersMsg: "Your Name must have at least 3 characters",
// });
//
// //String
// export const Text = Object.freeze({
//     //Login
//     username: "Username",
//     password: "Password",
//     loginToDashboard: "Login To Dashboard",
//     forgotPassword: "Forgot Password?",
//     login: "Log in",
//     email: "Email",
//
//     //Main
//     getStarted: "Get Started!",
//     loginToYourPortalBelow: "Log in to your portal below",
//     logIn: "Log In",
//     signUp: "Sign Up",
//
//     //AppLogin
//     loginToImportYourProfile: "Log in to import your profile",
//     emailPhoneOrUsername: "Email, phone or username",
//     cancel: "Cancel",
//
//     //NameSection
//     whatMayWeCallYou: "Hi, what may we call you?",
//     enterYourFullName: "Enter your full name",
//     name: "Name",
//     byContinuingIagree: "By continuing I agree that I have read and accepted the",
//     termsOfUse: "Terms of use",
//     and: "and",
//     privacyPolicy: "Privacy Policy",
//     next: "Next",
// });